export default __webpack_public_path__ + "static/media/Signal.c45e96e9.svg";